import { MdDeleteOutline, MdOutlineEdit } from "react-icons/md";

interface FileCardProps {
  stepsNumber: number;
  onEditClick?: () => void;
  onDeleteClick?: () => void;
}

const FileCard: React.FC<FileCardProps> = ({
  stepsNumber,
  onEditClick,
  onDeleteClick,
}) => {
  return (
    <div className="self-stretch px-3 py-4 rounded-xl border border-Subtle justify-between items-center flex gap-3">
      <div className="inline-flex flex-col justify-start items-start gap-1 flex-grow min-w-0 overflow-hidden">
        <div className="text-neutral-700 text-base font-normal font-sans leading-[19px] truncate w-full select-none">
          Instructions
        </div>
        <div className="self-stretch justify-start items-start gap-2 inline-flex">
          <div className="justify-start items-start gap-1 flex select-none">
            <div className="text-neutral-500 text-xs font-normal font-sans leading-[14px]">
              Steps
            </div>
            <div className="text-neutral-500 text-xs font-normal font-sans leading-[14px]">
              {stepsNumber}
            </div>
          </div>
        </div>
      </div>
      {/* Edit button */}
      <div
        className="p-2 bg-neutral-50 hover:bg-neutral-100 ease-in-out duration-150 rounded-full justify-start items-start gap-2 flex cursor-pointer"
        onClick={onEditClick}
      >
        <MdOutlineEdit className="w-6 h-6 fill-neutral-600" />
      </div>
      {/* Delete button */}
      <div
        className="p-2 bg-neutral-50 hover:bg-neutral-100 ease-in-out duration-150 rounded-full justify-start items-start gap-2 flex cursor-pointer"
        onClick={onDeleteClick}
      >
        <MdDeleteOutline className="w-6 h-6 fill-neutral-600" />
      </div>
    </div>
  );
};

export default FileCard;
